import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withInterpolate } from 'decorators/Interpolate/Interpolate';
import { decorateWith, withName } from 'helpers/decorator';
import { VARIABLE_REGEX as DOLLAR_SIGN_REGEX } from 'helpers/interpolate';
import { isEmpty } from 'helpers/verify';
import { CallToAction, ACTIONS } from 'components/CallToAction';
import { Section } from 'components/Section/Section';
import { selectSelectedOffer } from 'redux/modules/offer';
import { MultiOffers } from '../components/MultiOffers';
import { SingleOffer } from '../components/SingleOffer';
import { updateSubmittedOffer } from '../sagas/product.saga';

export class ProductCardUnwrapped extends Component {
  handleSelectOfferClick = () => {
    const { selectedOffer } = this.props;
    this.props.updateSubmittedOffer(selectedOffer);
  };

  renderTag() {
    const { interpolate: interpolator, tag } = this.props;
    const interpolate = interpolator || (text => text);
    return tag && <p className="ProductCard__tag">{interpolate(tag)}</p>;
  }

  renderSingleOffer() {
    const { cmsModuleId, offers } = this.props;
    const offer = offers[0] || {};
    return <SingleOffer cmsModuleId={cmsModuleId} offer={offer} />;
  }

  renderMultipleOffers() {
    const { checkFirstOfferByDefault, cmsModuleId, offers } = this.props;
    return (
      <MultiOffers checkFirstOfferByDefault={checkFirstOfferByDefault} cmsModuleId={cmsModuleId} offers={offers} />
    );
  }

  renderOffers() {
    const { offers, showMultipleOffers } = this.props;

    if (isEmpty(offers)) {
      return null;
    }

    return showMultipleOffers && offers.length > 1 ? this.renderMultipleOffers() : this.renderSingleOffer();
  }

  formatProductCardCta() {
    const [firstOffer] = this.props.offers;
    return (
      firstOffer.ctaCopy &&
      firstOffer.url && (
        <CallToAction
          action={ACTIONS.LINK}
          color="primary_solid"
          extraClass="bt--lg bt--width-full"
          to={firstOffer.url}>
          {firstOffer.ctaCopy}
        </CallToAction>
      )
    );
  }

  render() {
    const { showMultipleOffers } = this.props;
    const cta = this.props.cta || this.formatProductCardCta();
    return (
      <div className="card">
        <Section
          className={classNames('ProductCard', {
            'ProductCard--single-offer': !showMultipleOffers,
          })}>
          {this.renderTag()}
          {this.renderOffers()}
          {cta && (
            <div
              className={classNames('ProductCard__cta', {
                'ProductCard--multi-offers__cta': showMultipleOffers,
              })}
              onClick={this.handleSelectOfferClick}>
              {cta}
            </div>
          )}
        </Section>
      </div>
    );
  }
}

ProductCardUnwrapped.propTypes = {
  checkFirstOfferByDefault: PropTypes.bool,
  cmsModuleId: PropTypes.string.isRequired,
  cta: PropTypes.node,
  interpolate: PropTypes.func,
  offers: PropTypes.arrayOf(PropTypes.object),
  selectedOffer: PropTypes.object,
  showMultipleOffers: PropTypes.bool,
  tag: PropTypes.string,
  updateSubmittedOffer: PropTypes.func.isRequired,
};

export const mapStateToProps = state => {
  return {
    selectedOffer: selectSelectedOffer(state) || {},
  };
};

export const mapDispatchToProps = {
  updateSubmittedOffer,
};

export const ProductCard = decorateWith(
  withInterpolate(DOLLAR_SIGN_REGEX),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('ProductCard')
)(ProductCardUnwrapped);
